// extracted by mini-css-extract-plugin
export default {"pageBox":"PageBox_pageBox__DLSvs"};